<template>
    <div class="nc-detail">

        <div class="nc-detail__top">
            <new-chat-drivers v-if="drivers.length" :drivers="drivers" />

            <div class="nc-detail__row">
                <span class="nc-detail__label">Клиент:</span>
                <span class="nc-detail__value">{{ customerName }}</span>
            </div>
        </div>

        <new-chat-history-messenger v-if="customerId" :customer-id="customerId" />

    </div>
</template>

<script>
import api from '@api'
import NewChatHistoryMessenger from '../messenger/NewChatHistoryMessenger.vue'
import NewChatDrivers from './NewChatDrivers.vue'

export default {
    name: 'NewChatHistoryDetail',
    components: {
        NewChatHistoryMessenger,
        NewChatDrivers,
    },
    props: {
        chat: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            drivers: [],
        }
    },
    computed: {
        customerId() {
            const ci = this.chat.customer_info
            return ci && typeof ci === 'object' ? ci.id : null
        },
        customerName() {
            const ci = this.chat.customer_info
            if (!ci) return ''
            return typeof ci === 'object' ? ci.text : ci
        },
        customerPhone() {
            const match = this.chat.customer_info.phone
            return match ? match : ''
        },
    },
    mounted() {
        if (this.customerPhone) this.fetchDrivers()
    },
    methods: {
        fetchDrivers() {
            api.newChat.getDriversList({ phone: this.customerPhone })
                .then(response => {
                    this.drivers = Array.isArray(response) ? response : []
                })
                .catch(err => {
                    console.error('[NewChat] history drivers error:', err)
                })
        },
    },
}
</script>